import { Controller, useFormContext } from 'react-hook-form';
import AutoComplete, {
  AutoCompleteProps,
} from 'src/components/ui/AutoComplete';

export interface FormMultiSelectProps extends AutoCompleteProps {
  name: string;
}

const FormMultiSelect = ({ name, ...props }: FormMultiSelectProps) => {
  const { control, clearErrors } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { value, onChange, ...rest },
        fieldState: { invalid, error },
      }) => (
        <AutoComplete
          menuPosition="fixed"
          menuPortalTarget={document.body}
          menuShouldScrollIntoView={false}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          {...rest}
          {...props}
          data-rhf-name={name}
          defaultValue={value}
          onChange={(list: any) => {
            clearErrors(name);
            onChange(list);
          }}
          isInvalid={invalid}
          errorMessage={error?.message}
          isMulti
        />
      )}
    />
  );
};

export default FormMultiSelect;
